import { Link } from 'react-router-dom';

import LogoIconLight from 'assets/icons/logo-icon-light.png';
import LogoIconDark from 'assets/icons/logo-icon-dark.png';
import config, { Routes } from 'config/constants';

import useTheme from 'hooks/useTheme';
import { ThemeMode } from 'providers/ThemeProvider';

interface RyeLogoProps {
  to?: Routes;
  team?: string;
}

const RyeLogo = ({ to = config.routeDefaultHome, team }: RyeLogoProps) => {
  const { theme } = useTheme();
  const isLight = theme === ThemeMode.Light;

  return (
    <Link
      id="heap-logo-top-link-rye-com"
      className="logo-wrapper inline-flex items-center gap-2.5 font-mono text-[13px] font-medium tracking-[0.02em] no-underline"
      to={to}
    >
      <span className="logo-mark inline-flex h-[22px] w-[26px] items-center justify-center">
        <img
          className="block max-h-full max-w-full"
          src={isLight ? LogoIconLight : LogoIconDark}
          alt=""
        />
      </span>
      <span className="text-[var(--text)]">rye</span>
      <span className="text-[var(--text-soft)]">/</span>
      <span className="text-[var(--text)]">console</span>
      {team && (
        <>
          <span className="select-none text-[var(--text-soft)]">·</span>
          <span className="font-mono text-[13px] font-normal text-[var(--text-muted)]">{team}</span>
        </>
      )}
    </Link>
  );
};

export default RyeLogo;
